// Diletta's actual platform widget chrome — exact values from
// src/components/v2/widget/styles.scss .general-widget-container.
// These are the values used by every rendered Market Data / Portfolio /
// OTC Trader widget on production. The exotics surface mirrors them so
// the page reads as part of the platform rather than a foreign island.
//
// Don't substitute palette tokens here — gray[8] / primary[7] / etc. are
// arbitrary picks that don't match what production actually paints.

import type { SxProps, Theme } from '@mui/material';

// Container chrome — outer wrapper of a widget-like surface.
export const dilettaPanelSx: SxProps<Theme> = {
  border: '1px solid #026aa2',
  backgroundColor: 'rgba(40, 114, 226, 0.10)', // #2872e21a unpacked
  borderRadius: '16px',
  boxShadow: '0px 1px 2px 0px #00000059, 0px 2px 6px 2px #00000026',
  backdropFilter: 'blur(16px)',
  boxSizing: 'border-box',
};

// Cell chrome — inner cards that sit on top of the container. The
// border uses #1f3645 (highlightLevel1) rather than the brighter
// #416077 — at the per-cell scale the brighter colour competed with
// the row separators and read as "white" on the dark background.
export const dilettaCellSx: SxProps<Theme> = {
  border: '1px solid #1f3645',
  backgroundColor: 'rgba(40, 114, 226, 0.06)',
  borderRadius: '6px',
};

// Section divider — used between band-rows.
export const DILETTA_DIVIDER = '#416077';

// Banner row background — TRADE / etc. headers. Matches highlightLevel1
// (#1f3645) from src/styles/_colors.scss.
export const DILETTA_BANNER_BG = '#1f3645';

// Title text — light cyan-white used for widget titles (#c2e5ff in
// .widget-title-container).
export const DILETTA_TITLE = '#c2e5ff';

// Border / outline colour used elsewhere in the platform.
export const DILETTA_BORDER = '#026aa2';
